/* ui event enums */

export const UPDATE_UNREAD_MESSAGE_COUNT = 'ui/UPDATE_UNREAD_MESSAGE_COUNT';
export const WIDGET_AUTO_SHOW = 'ui/WIDGET_AUTO_SHOW';
export const WIDGET_HIDE = 'ui/WIDGET_HIDE';
export const WIDGET_INITIATE = 'ui/WIDGET_INITIATE';
export const WIDGET_MINIMIZE = 'ui/WIDGET_MINIMIZE';
export const WIDGET_SUPPRESS = 'ui/WIDGET_SUPPRESS';
export const WIDGET_UNSUPPRESS = 'ui/WIDGET_UNSUPPRESS';
export const WIDGET_UNMINIMIZE = 'ui/WIDGET_UNMINIMIZE';
export const WIDGET_UPDATE_COMPOSITION_DRAFT = 'ui/WIDGET_UPDATE_COMPOSITION_DRAFT';
export const WIDGET_UPDATE_STAGE = 'ui/WIDGET_UPDATE_STAGE';
export const WIDGET_UPDATE_VISIBILITY = 'ui/WIDGET_UPDATE_VISIBILITY';
export const WIDGET_NAVIGATE_FORWARD = 'ui/WIDGET_NAVIGATE_FORWARD';
export const WIDGET_NAVIGATE_BACK = 'ui/WIDGET_NAVIGATE_BACK';

export const uiEventTypes = {
  UPDATE_UNREAD_MESSAGE_COUNT,
  WIDGET_AUTO_SHOW,
  WIDGET_HIDE,
  WIDGET_INITIATE,
  WIDGET_MINIMIZE,
  WIDGET_SUPPRESS,
  WIDGET_UNSUPPRESS,
  WIDGET_UNMINIMIZE,
  WIDGET_UPDATE_COMPOSITION_DRAFT,
  WIDGET_UPDATE_STAGE,
  WIDGET_UPDATE_VISIBILITY,
  WIDGET_NAVIGATE_FORWARD,
  WIDGET_NAVIGATE_BACK,
};

/* ui events */

export const autoShowWidget = () => ({ type: WIDGET_AUTO_SHOW });
export const unminimizeWidget = () => ({ type: WIDGET_UNMINIMIZE });
export const hideWidget = () => ({ type: WIDGET_HIDE });
export const suppress = () => ({ type: WIDGET_SUPPRESS });
export const unsuppress = () => ({ type: WIDGET_UNSUPPRESS });
export const navigateBack = () => ({ type: WIDGET_NAVIGATE_BACK });

export const initWidget = ({ orgDomain, loginDomain, appId, providerId, orgId, cdn }) => {
  return {
    type: WIDGET_INITIATE,
    payload: { orgDomain, loginDomain, appId, providerId, orgId, cdn },
  };
};

export const updateCompositionDraft = text => {
  return {
    type: WIDGET_UPDATE_COMPOSITION_DRAFT,
    payload: { text },
  };
};

export const updateStage = stage => {
  return {
    type: WIDGET_UPDATE_STAGE,
    payload: { stage },
  };
};

export const updateVisibility = isVisible => {
  return {
    type: WIDGET_UPDATE_VISIBILITY,
    payload: { isVisible },
  };
};

export const navigateForward = location => {
  return {
    type: WIDGET_NAVIGATE_FORWARD,
    payload: { location },
  };
};

export default {
  autoShowWidget,
  unminimizeWidget,
  hideWidget,
  suppress,
  unsuppress,
  navigateBack,
  initWidget,
  updateCompositionDraft,
  updateStage,
  updateVisibility,
  navigateForward,
};
